import Carousel from './Carousel';
import useCarousel from './useCarousel';

export default Carousel;
export { useCarousel };
